import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-primary-banner',
  templateUrl: './primary-banner.component.html',
  styleUrls: ['./primary-banner.component.css'],
  imports: [RouterLink],
})
export class PrimaryBannerComponent {
  @Input() title: string;
  @Input() text: string;
  @Input() link: string;
  @Input() linkText: string;
}
